import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionService } from 'src/app/auth/session.service';
import { OperationInfoService } from 'src/app/common/long-operations/operation-info.service';
import { EventTypes } from 'src/app/common/shared/observer.enum';
import { Observer } from 'src/app/common/shared/observer.interface';
import { FormConstructorComponent } from 'src/app/forms/form-constructors/form-constructor/form-constructor.component';
import { FormStateService } from 'src/app/forms/form-state.service';
import { FormConstructorContent } from 'src/app/interfaces/form-and-field.interface';
import { safelyDetectChanges } from '../../common/app.helpers';
import { ContactUsService } from './contact-us.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  providers: [ContactUsService],
})
export class ContactUsComponent implements Observer, OnInit, OnDestroy {
  public formContent: FormConstructorContent;
  public isDisabledSubmitButton = false;
  public isAuthenticated = false;
  public contactMail = 'hello@1life2connect.com';

  private subscriptions$: Subscription[] = [];

  @ViewChild(FormConstructorComponent, { static: false }) private contactUsForm: FormConstructorComponent;

  private observerEventTypesMapper: {
    [key in EventTypes]: (data: FormConstructorContent) => void;
  } = {
    [EventTypes.UPDATE]: (data: FormConstructorContent) => (this.formContent = data),
  };

  private contactUsService = inject(ContactUsService);
  private formStateService = inject(FormStateService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private sessionService = inject(SessionService);
  private operationService = inject(OperationInfoService);

  public ngOnInit(): void {
    this.contactUsService.subscribeOnChanges(this);
    this.subscribeToSessionChanges();
  }

  public ngOnDestroy(): void {
    this.contactUsService.unsubscribeFromChanges(this);
  }

  public sendMessage(event: Event): void {
    this.formStateService.stopAllAction(event);

    if (this.contactUsForm.childForm.isFormValid()) {
      this.isDisabledSubmitButton = true;

      this.contactUsForm.prepareSubmitData();

      this.operationService.setupOperation({ successfulMessage: 'CONTACT_US_SUCCESSFUL_MSG_SEND_DESCRIPTION' }, () => {
        this.contactUsService.sendMessage({
          subject: this.contactUsForm.formContent.data['subject'] as string,
          message: this.contactUsForm.formContent.data['message'] as string,
        });
      });
    }
  }

  public update(event: EventTypes, data: FormConstructorContent): void {
    this.observerEventTypesMapper[event](data);
    safelyDetectChanges(this.changeDetectorRef);
  }

  private subscribeToSessionChanges(): void {
    this.subscriptions$.push(
      this.sessionService.sessionChanges.subscribe(() => {
        this.isAuthenticated = this.sessionService.isSessionActive();
      }),
    );
    this.isAuthenticated = this.sessionService.isSessionActive();
  }
}
